import React from 'react'

export const UpdatePtz = () => {
  return (
    <div>
      
    </div>
  )
}


